function openTab(evt, tabId) {
  var i, tabcontent, tablinks;

  // Get all tab contents and links
  tabcontent = document.getElementsByClassName("tabcontent");
  tablinks = document.getElementsByClassName("tablinks");

  // Hide all tab contents smoothly
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].classList.remove("active-tab"); // Remove active class
  }

  // Remove active class from all tab links
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
  }

  // Show the selected tab content
  let selectedTab = document.querySelector(`.tabcontent[id='${tabId}']`);
  if (selectedTab) {
    selectedTab.classList.add("active-tab"); // Apply smooth transition effect
  }

  // Add active class to the clicked tab
  if (evt) {
    evt.currentTarget.classList.add("active");
  } else {
    let defaultBtn = document.querySelector(`[data-tab='${tabId}']`);
    if (defaultBtn) {
      defaultBtn.classList.add("active");
    }
  }

  // Initialize or refresh Slick Slider
  setTimeout(() => {
    let slider = selectedTab.querySelector(".product__Slider");
    if (slider) {
      if (!$(slider).hasClass("slick-initialized")) {
        $(slider).slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 4,
          adaptiveHeight: true,
          centerMode: false,
          prevArrow: '<button type="button" class="slick-prev" aria-label="Previous">' +
            '<span class="custom-arrow"><svg style="transform: rotate(180deg);" xmlns="http://www.w3.org/2000/svg" width="12.264" height="21.699" viewBox="0 0 12.264 21.699"><path stroke="#fff" stroke-width="2" fill="none" d="M-74,254.8l10.142,10.142L-74,275.084" transform="translate(74.707 -254.092)"/></svg></span>' +
            "</button>",
          nextArrow: '<button type="button" class="slick-next" aria-label="Next">' +
            '<span class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="12.264" height="21.699" viewBox="0 0 12.264 21.699"><path stroke="#fff" stroke-width="2" fill="none" d="M-74,254.8l10.142,10.142L-74,275.084" transform="translate(74.707 -254.092)"/></svg></span>' +
            "</button>",
          responsive: [{
              breakpoint: 900,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true
              }
            },
            {
              breakpoint: 549,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
              }
            },
          ],
        });
      } else {
        $(slider).slick("refresh").slick("setPosition");
      }
    }
  }, 10);
}

// Ensure default tab opens on page load smoothly
document.addEventListener("DOMContentLoaded", () => {
  let firstTabButton = document.querySelector(".tablinks");
  let firstTabContent = document.querySelector(".tabcontent");

  if (firstTabContent) {
    firstTabContent.classList.add("active-tab");
  }

  if (firstTabButton) {
    firstTabButton.classList.add("active");
    setTimeout(() => {
      firstTabButton.click();
    }, 100);
  }
});